// extracted by mini-css-extract-plugin
export default {"whywe":"Whywe_whywe__1srSc","inner":"Whywe_inner__HZ0rU"};